
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowDownAlt = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 19.5a2.3 2.3 0 01-1.729-.78L.46 7.568a1.847 1.847 0 012.773-2.439l8.579 9.752a.25.25 0 00.376 0l8.579-9.752a1.847 1.847 0 112.773 2.439l-9.808 11.148A2.31 2.31 0 0112 19.5z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12.04 18.867c-.286 0-.559-.123-.749-.336L.167 5.957a.499.499 0 11.749-.662l11.125 12.573L23.167 5.295a.501.501 0 01.706-.044.5.5 0 01.043.706L12.79 18.531a1.006 1.006 0 01-.75.336z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 18.999c-.4 0-.776-.156-1.059-.438L.22 7.841A.745.745 0 010 7.31c0-.2.078-.389.22-.53a.744.744 0 011.06 0L12 17.499 22.72 6.78a.744.744 0 011.06 0 .744.744 0 010 1.06L13.06 18.56a1.487 1.487 0 01-1.06.439z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowDownAlt.displayName = 'IconArrowDownAlt';
export default IconArrowDownAlt;